/* Colour circles that link to the same model in another colour.

   Liquid cannot look products up by metafield, so the group is fetched from a
   collection filtered on custom.color_group and rendered through the Section
   Rendering API. Until it arrives the page already shows this product's own
   circle and colour name, and if the fetch fails or the filter is not enabled
   in Search & Discovery that is simply what stays — never an empty row. */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('color-siblings')) return;

  var ColorSiblings = function () {
    return Reflect.construct(HTMLElement, [], ColorSiblings);
  };

  ColorSiblings.prototype = Object.create(HTMLElement.prototype);
  ColorSiblings.prototype.constructor = ColorSiblings;
  Object.setPrototypeOf(ColorSiblings, HTMLElement);

  ColorSiblings.prototype.connectedCallback = function () {
    if (this.loaded) return;
    this.loaded = true;

    var endpoint = this.getAttribute('data-siblings-endpoint');
    var current = this.getAttribute('data-siblings-current');
    var list = this.querySelector('[data-siblings-list]');
    if (!endpoint || !list) return;

    var element = this;

    fetch(endpoint)
      .then(function (response) {
        if (!response.ok) throw new Error('siblings ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var root = parsed.querySelector('[data-siblings-root]');
        var found = root ? root.querySelectorAll('[data-sibling-handle]') : [];

        /* One result is this product on its own: the group is not really a
           group, and the circle already on the page says everything. */
        if (found.length < 2) return;

        list.innerHTML = '';
        Array.prototype.forEach.call(found, function (link) {
          var handle = link.getAttribute('data-sibling-handle');
          if (handle === current) {
            link.classList.add('is-selected');
            link.setAttribute('aria-current', 'true');
          }
          list.appendChild(document.importNode(link, true));
        });

        element.setAttribute('data-siblings-count', found.length);
      })
      .catch(function (error) {
        console.warn('[color-siblings] could not load the colour group:', error);
      });
  };

  customElements.define('color-siblings', ColorSiblings);
})();
